module.exports = __webpack_public_path__ + "static/media/Logo_teametud_1.ad8438ed.svg";